import React from 'react';
import { FaArrowLeft, FaArrowRight, FaCalendarAlt } from 'react-icons/fa';

/**
 * Componente de encabezado del calendario
 */
const CalendarHeader = ({ currentDate, onPrevMonth, onNextMonth, onToday }) => {
  return (
    <div className="flex justify-between items-center mb-4 bg-gray-800 p-3 rounded-lg border border-gray-700">
      <button 
        onClick={onPrevMonth}
        className="p-2 px-4 bg-gray-700 hover:bg-blue-600 text-xl transition-colors rounded-lg shadow-md flex items-center justify-center"
        aria-label="Mes anterior"
      >
        <FaArrowLeft size={20} />
      </button>
      
      <h2 className="text-xl font-bold flex items-center">
        <FaCalendarAlt className="mr-2" />
        {currentDate.format('MMMM YYYY')}
      </h2>
      
      <button 
        onClick={onNextMonth}
        className="p-2 px-4 bg-gray-700 hover:bg-blue-600 text-xl transition-colors rounded-lg shadow-md flex items-center justify-center"
        aria-label="Mes siguiente"
      >
        <FaArrowRight size={20} />
      </button>
    </div>
  );
};

export default CalendarHeader;
